export default {
    url: '/review',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManagePerformanceReviews();
        }
    },
    abstract: true,
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/review/index.js